<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AppConstants from './constants/app.constants'
import CssUtils from './_helpers/css.util'
export default {
  name: 'App',
  mounted: function() {
    document.body.style.backgroundColor = '#F8F8F8'
    // ドキュメントのデフォルトのフォント サイズを設定する
    const computedStyle = window.getComputedStyle(document.documentElement)
    const fontSize = computedStyle.getPropertyValue('font-size')
    CssUtils.setCssVariable(AppConstants.DEFAULT_BROWSER_FONT_SIZE_VARIABLE_NAME, fontSize.replace('px', ''))
    // デフォルトのビューポート幅と設定ウィザードのメニューステータスに基づいてメインビューのフォントサイズを更新します
    CssUtils.setCssVariable(AppConstants.DEFAULT_VIEWPORT_WIDTH_VARIABLE_NAME, AppConstants.DEFAULT_VIEWPORT_WIDTH)
    // 成功/エラーメッセージのアニメーション時間 (秒)
    CssUtils.setCssVariable(AppConstants.ALERT_MESSAGE_ANIMATION_TIME_VARIABLE_NAME, AppConstants.ALERT_MESSAGE_ANIMATION_TIME)
    // 1 行のデフォルトのメッセージの高さを設定する
    CssUtils.setCssVariable(AppConstants.DEFAULT_MESSAGE_HEIGHT_VARIABLE_NAME, AppConstants.DEFAULT_MESSAGE_HEIGHT.toString().concat('px'))
    window.addEventListener('resize', this.onResize)
    this.updateMainViewFontSize(this.getMenuStatus)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    ...mapGetters('settingWizardStore', ['getMenuStatus'])
  },
  watch: {
    getMenuStatus(newVal) {
      this.updateMainViewFontSize(newVal)
    }
  },
  methods: {
    /**
     * メインビューのフォントサイズを更新します。
     *
     * @param {number} settingWizardMenuStatus - 設定ウィザードメニューのステータス
     */
    updateMainViewFontSize(settingWizardMenuStatus) {
      let mainViewWidth = window.innerWidth
      if (settingWizardMenuStatus) {
        mainViewWidth -= AppConstants.SETTING_WIZARD_MENU_WIDTH
      }
      if (mainViewWidth < AppConstants.MAIN_VIEW_MIN_WIDTH) {
        mainViewWidth = AppConstants.MAIN_VIEW_MIN_WIDTH
      }
      CssUtils.setCssVariable(AppConstants.MAIN_VIEW_WIDTH_VARIABLE_NAME, mainViewWidth)
    },
    /**
     * ウィンドウのサイズ変更。
     */
    onResize() {
      this.updateMainViewFontSize(this.getMenuStatus)
    }
  }
}
</script>
<style lang='scss'>
</style>



// WEBPACK FOOTER //
// src/App.vue